import Button from 'core/components/buttons/Button'
import notFoundIllustration from 'assets/images/404.png'
import useNavigation from 'core/hooks/navigation/useNavigation'
import { DashboardUrl } from 'constants/RouteUrls'
import LinkButton from 'core/components/buttons/LinkButton'
import { LINK_EVERLANCE_CONTACT_US } from 'constants/Links'

const NotFoundPage = () => {
  const { replace } = useNavigation()
  return (
    <div className="flex flex-col items-center text-center gap-12 mt-10">
      <div>
        <img
          src={notFoundIllustration}
          alt="Not found illustration"
          className="w-56"
        />
      </div>
      <h1 className="text-4xl font-bold">404 - Page not found</h1>
      <div>
        <h4>We couldn't find the page you are looking for.</h4>
        <h4>
          Need more help?{' '}
          <LinkButton
            className="text-lg text-primary-3 hover:underline"
            text="Contact support"
            url={LINK_EVERLANCE_CONTACT_US}
          />
        </h4>
      </div>
      <Button
        variant="primary"
        onClick={() => {
          replace(DashboardUrl)
        }}
      >
        Back to home
      </Button>
    </div>
  )
}

export default NotFoundPage
